<template>
  <sdCards :title="$t('pages.apps.other.title')">
    <a-form layout="vertical" :model="formData" @submit="handleSubmit">
      <a-form-item :label="$t('pages.apps.other.category')">
        <a-select v-model:value="app.category" required>
          <a-select-option :value="0">
            {{ this.$t('common.choose') }}
          </a-select-option>
          <a-select-option :value="category.id" v-for="category in categories" :key="category">
            {{ category.title }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('pages.apps.other.perms')">
        <a-tree-select
          style="width: 100%"
          v-model:value="app.permsArray"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :placeholder="$t('pages.apps.other.perms-place')"
          allow-clear
          multiple
        >
          <a-tree-select-node
            v-for="permission in permissions"
            :key="permission.id"
            :value="permission.id"
            :title="$store.state.i18n.i_lang == 'en' ? permission.title_en : permission.title"
          />
        </a-tree-select>
      </a-form-item>
      <a-form-item :label="$t('pages.apps.other.video')">
        <a-input v-model:value="app.video" />
      </a-form-item>
      <a-form-item :label="$t('pages.apps.other.tsoft-version')">
        <a-input v-model:value="app.required_version" />
      </a-form-item>
      <a-form-item :label="$t('pages.apps.other.allowed-domains')">
        <a-textarea
          v-model:value="app.allowed_domains"
          :placeholder="$t('pages.apps.other.allowed-domains')"
          :rows="2"
        />
      </a-form-item>
      <a-form-item label="&nbsp;">
        <a-button type="primary" :loading="iconLoading" html-type="submit"> {{ $t('common.save') }} </a-button>
      </a-form-item>
    </a-form>
  </sdCards>

  <sdCards>
    <a-form layout="vertical">
    <a-form-item :label="$t('pages.apps.other.test-your-app')">
      <p>{{ $t('pages.apps.other.test-message') }}</p>
      <a-button type="primary" :loading="iconLoading2" @click="this.isModalVisible = true">
        {{ $t('pages.apps.other.create-ticket') }}
      </a-button>
    </a-form-item>
    </a-form>
  </sdCards>

  <a-modal v-model:visible="isModalVisible" :title="$t('pages.apps.other.modal-title')" @ok="createTicket">
    <a-textarea v-model:value="ticketNote" :placeholder="$t('pages.apps.other.modal-placeholder')" :rows="5" />
  </a-modal>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Other',
  components: {},
  data() {
    return {
      isModalVisible: false,
      categories: [],
      permissions: [],
      iconLoading2: false,
      iconLoading: false,
      formData: {},
      select: null,
      app_id: this.$route.params.id,
      ticketNote: '',
    };
  },
  methods: {
    createTicket() {
      this.iconLoading2 = true;
      var ticket = {
        title: this.$t('pages.apps.other.modal-title'),
        content: this.ticketNote,
        type: 'demo',
      };
      this.$appAxios
        .post(this.$endpoints.ticket_create, ticket)
        .then(resp => {
          if (resp.data.status === true) {
            this.$message.success(this.$t('common.success-message'));
            this.isModalVisible = false;
          } else {
            this.$message.error(resp.data.message, 4);
          }
          this.iconLoading2 = false;
        })
        .catch(e => {
          this.iconLoading2 = false;
          this.$message.error(this.$t('common.error-message'));
        });
    },
    handleSubmit() {
      this.formData = {
        app_id: this.app_id,
        category: this.app.category,
        permissions: this.app.permsArray,
        video: this.app.video,
        version: this.app.version,
        required_version: this.app.required_version,
        allowed_domains: this.app.allowed_domains,
      };

      if (this.app.permsArray == null || this.app.permsArray.length < 1) {
        this.$message.error('En az 1 izin seçilmelidir');
        return false;
      }

      this.$appAxios.post(this.$endpoints.app_other_update, this.formData).then(resp => {
        if (resp.data.status) {
          this.$message.success('Başarıyla Güncellendi');
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    getCategories() {
      this.$appAxios.post(this.$endpoints.categories_get).then(resp => {
        if (resp.data.status) {
          this.categories = resp.data.data;
        }
      });
    },
    getPermissions() {
      this.$appAxios.post(this.$endpoints.permissions_get).then(resp => {
        if (resp.data.status) {
          this.permissions = resp.data.data;
        }
      });
    },
  },
  mounted() {
    this.getCategories();
    this.getPermissions();
  },
  created() {},
  computed: {
    ...mapGetters({
      app: 'application/app_detail',
    }),
  },
};
</script>
